import _          from 'lodash'
import moment     from 'moment'
import Backend    from 'alto-utils/lib/backend'
import Auth       from 'alto-react-base-auth/lib/client'
import { Client } from 'alto-react-kredit/lib/models'
import { User   } from 'alto-react-client-auth/lib/models'

class ClientAuthStorage extends Auth.Storage
  @fields:
    Auth.Storage.fields.concat([
      { name: 'client', \
        serializer: Client.serialize.bind(Client), deserializer: Client.deserialize.bind(Client) },
      { name: 'profileComplete' }
    ])

class ClientAuthBackend extends Auth.Backend
  getClientsForSelect: ->
    @backend.request('GET', '/auth/get_clients_for_select').then (response) =>
      { clients: response.results.clients.map (row) -> Client.deserialize(row) }

  getClientToken: (username, password) ->
    @backend.request('POST', '/auth/get_client_token', body: { username, password })
      .then(@getTokenHandler)

  getClientTokenByCard: (cardNumber, password) ->
    @backend.request('POST', '/auth/get_client_token_by_card', \
                    body: { card_number: cardNumber, password })
      .then(@getTokenHandler)

  getTokenHandler: (response) ->
    _.assign({ client: response.client and Client.deserialize(response.client), \
               profileComplete: response.profile_complete },
             super(response))

  clientByCard: (cardNumber) ->
    @backend.request('GET', '/auth/client_by_card', qs: { card_number: cardNumber })

  registerClient: (cardNumber, { email, username, password, useEmailAsUsername = false }) ->
    @backend.request('POST', '/auth/register_client',
                    qs:   { card_number: cardNumber, redirect: @frontendUrl },
                    body: { use_email_as_username: useEmailAsUsername, email, username, password })

  registerClientWithBV: (cardNumber, { email, username, password, useEmailAsUsername = false,
                         billNumber, billDate }) ->
    body =
      use_email_as_username: useEmailAsUsername
      email:       email
      username:    username
      password:    password
      bill_number: billNumber
      bill_date:   if moment.isMoment(billDate) then billDate.format('YYYY-MM-DD') else billDate

    @backend.request('POST', '/auth/register_client_with_bv',
                    qs:   { card_number: cardNumber, redirect: @frontendUrl },
                    body: body)

  getClient: ->
    @backend.requestWithToken(@storage.token, 'GET', '/auth/get_client')
      .then (response) ->
        { client: Client.deserialize(response.client), type: response.type }

  editClient: (attrs) ->
    @backend.requestWithToken(@storage.token, 'PATCH', '/auth/edit_client',
                              body: Client.serialize(attrs))
      .then (row) -> { client: Client.deserialize(row.client), user: User.deserialize(row.user) }

  changePassword: (currentPassword, newPassword, pin) ->
    body = { pin, current_password: currentPassword, new_password: newPassword }

    @backend.requestWithToken(@storage.token, 'POST', '/auth/change_password', { body })
      .then => @storage.setHasPassword(true)

  isProfileComplete: ->
    @backend.requestWithToken(@storage.token, 'GET', '/auth/is_profile_complete')

  setClientType: (type) ->
    @backend.requestWithToken(@storage.token, 'PATCH', '/auth/set_client_type',
                              body: { type: type })

  deleteUser: (clearSensitiveData) ->
    @backend.requestWithToken(@storage.token, 'DELETE', '/auth/delete_user',
                              qs: { clear_sensitive_data: clearSensitiveData })

class ClientAuth extends Auth
  @storageClass: ClientAuthStorage
  @backendClass: ClientAuthBackend

  logInClient: (username, password) ->
    @backend.getClientToken(username, password)
      .then (response) => @storage.save(response)

  logInClientByCard: (cardNumber, password) ->
    @backend.getClientTokenByCard(cardNumber, password)
      .then (response) => @storage.save(response)

  editClient: (attrs) ->
    @backend.editClient(attrs).then ({ client, user }) =>
      @storage.update(user, client)

      @backend.isProfileComplete().then (isCompleteResponse) =>
        @storage.update(profileComplete: isCompleteResponse.is_complete)

        return
          user:             user
          client:           client
          isComplete:       isCompleteResponse.is_complete
          isCompleteDetail: isCompleteResponse.detail

  getClient:            (args...) -> @backend.getClient(args...)
  clientByCard:         (args...) -> @backend.clientByCard(args...)
  setClientType:        (args...) -> @backend.setClientType(args...)
  registerClient:       (args...) -> @backend.registerClient(args...)
  getClientsForSelect:  (args...) -> @backend.getClientsForSelect(args...)
  registerClientWithBV: (args...) -> @backend.registerClientWithBV(args...)

  Object.defineProperty(@::, 'isClient',          get: -> @authInfo?.client?)
  Object.defineProperty(@::, 'loggedInClient',    get: -> @authInfo?.client)
  Object.defineProperty(@::, 'isProfileComplete', get: -> @authInfo?.profileComplete)

ClientAuth.Storage = ClientAuthStorage
ClientAuth.Backend = ClientAuthBackend

export default ClientAuth
